module.exports = __webpack_public_path__ + "static/media/E43CBFC1-692C-430E-897D-A92BC655F5B7.a173e952.JPG";